
import { supabase } from '@/integrations/supabase/client';

export const getGoogleMapsApiKey = async (): Promise<string | null> => {
  try {
    // Try to get the API key from environment or fallback
    // In a Supabase edge function context, this would be available via Deno.env
    // For client-side, we'll need to make a request to an edge function
    const { data, error } = await supabase.functions.invoke('get-maps-key');
    
    if (error) {
      console.error('Error fetching Google Maps API key:', error);
      return null;
    }
    
    return data?.apiKey || null;
  } catch (error) {
    console.error('Failed to get Google Maps API key:', error);
    return null;
  }
};
